export default {
  AccountInforTable: {
    ProfileFooter: 'Phát triển bởi Công ty Cổ phần',
    AccountInfor: 'Thông tin tài khoản',
    EditInfor: 'Chỉnh sửa',
    AccountName: 'Số điện thoại ',
    Email: 'Email',
    FullName: 'Họ và tên',
    Password: 'Mật khẩu',
    NotUpdated: '<i style="color: #707070">Chưa cập nhật</i>',
    FullNamePlaceholder: 'Nhập họ và tên',
    EmailPlaceholder: 'Nhập địa chỉ email',
  },

  ChangePasswordTable: {
    ChangePassword: 'Đổi mật khẩu',
    CurrentPassword: 'Mật khẩu hiện tại',
    NewPassword: 'Mật khẩu mới',
    ConfirmPassword: 'Xác nhận mật khẩu',
  },

  LogoutTable: {
    LogoutDescription: 'Bạn có muốn đăng xuất<br> khỏi tài khoản này không?',
  },

  Message: {
    CanNotView: 'Bạn không thể xem thông tin hồ sơ của người khác',
    ProfileList: 'Danh sách hồ sơ',
    NoProfileYet: 'Chưa có thông tin hồ sơ nào',
    PleaseLogin: 'Vui lòng đăng nhập để xem thông tin chi tiết hồ sơ',
  },
}
